import type {BusinessCustomPropertiesDefinitionsPagePayload} from '@github-ui/custom-properties-types'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {Pagination} from '@primer/react'
import {useState} from 'react'

import {DefinitionsList} from '../components/DefinitionsPage'
import {DefinitionsPageHeader} from '../components/PropertiesHeaderPageTabs'
import {useBusinessPropertiesListResults} from '../hooks/use-properties-list'
import {DefinitionsFilter} from './DefinitionsFilter'

export function BusinessCustomPropertiesPage() {
  const payload = useRoutePayload<BusinessCustomPropertiesDefinitionsPagePayload>()
  const propertiesListExperienceEnabled = useFeatureFlag('enterprise_custom_properties_list')

  const [filterQuery, setFilterQuery] = useState('')

  const {
    payload: {totalCount, pageCount, definitions},
    currentPage,
    fetchResults,
  } = useBusinessPropertiesListResults({initialPayload: payload})

  return (
    <>
      <DefinitionsPageHeader permissions="definitions" definitions={definitions} />
      {propertiesListExperienceEnabled && (
        <DefinitionsFilter
          className="mb-3"
          filterValue={filterQuery}
          onChange={setFilterQuery}
          onSubmit={query => fetchResults({page: 1, filterQuery: query})}
        />
      )}

      <DefinitionsList totalCount={totalCount} definitions={definitions} />
      {propertiesListExperienceEnabled && pageCount > 1 && (
        <Pagination
          currentPage={currentPage}
          pageCount={pageCount}
          onPageChange={(e, page) => {
            e.preventDefault() // Prevent click event from navigating
            fetchResults({page, filterQuery})
          }}
        />
      )}
    </>
  )
}

try{ BusinessCustomPropertiesPage.displayName ||= 'BusinessCustomPropertiesPage' } catch {}